import {Component, EventEmitter, Input, Output} from '@angular/core';
import {DDP_PRICE_UNIT_SIZE, License, LicenseStatus} from './domain';

@Component({
  selector: 'app-google-ddp-prices',
  templateUrl: 'google-ddp-prices.component.html',
  styleUrls: ['google-ddp-prices.component.scss']
})
export class GoogleDdpPricesComponent {

  LicenseeStatus = LicenseStatus;

  UNIT_SIZE = DDP_PRICE_UNIT_SIZE;

  @Input() title!: string;
  @Input() licensee!: License[];
  @Input() editable = true;
  @Input() removable = true;
  @Output() priceEdited = new EventEmitter<License>();
  @Output() priceRemoved = new EventEmitter<License>();

  editPrice(licensee: License) {
    this.priceEdited.emit(licensee);
  }

  removePrice(licensee: License) {
    this.priceRemoved.emit(licensee);
  }
}
